<template>

  <div class="home-container">
    <header class="home-header">
      <div class="image-after"></div>
      <div class="container">
        <div class="header-top-bar">
          <span class="welcome-text">欢迎来到特资信大模型·特殊资产价值智评系统</span>
          <ul class="utility-links">
            <li>
              <router-link to="/about"  target="_blank"> 关于我们</router-link>
            </li>
            <li v-if="!show()">
              <router-link to="/login"> 登录</router-link>
            </li>
            <li v-if="!show()">
              <router-link to="/register"> 注册</router-link>
            </li>
            <li v-if="show()">
              <router-link to="/pay"> 充值中心</router-link>
            </li>
            <li v-if="show()">
              <router-link to="/user"> 个人中心</router-link>
            </li>
            <li v-if="show()">
              <a @click="loginout">退出</a>
            </li>
          </ul>


        </div>

        <div class="header-main">
          <div class="search-container">
            <h1 class="platform-title">特资信大模型·特殊资产价值智评系统</h1>
            <h3 class="platform-title-tag"> 特资信大模型，让特殊资产价值一目了然</h3>
            <div class="search-tabs">

              <ul class="tab-nav">
                <li :class="{ 'active': activeTab === 0 }"  @click="switchTab(0)">
                  <a>评企业</a>
                </li>
                <li :class="{ 'active': activeTab === 1 }"  @click="switchTab(1)">
                  <a>评个人</a>
                </li>
              </ul>
              <div class="tab-form">
                <a-form-model  ref="ruleForm"
                         :model="form"
                         :rules="rules"
                         :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }">
                  <a-form-model-item prop="entName" label="公司法定全称" v-if="this.activeTab==0">
                    <a-input v-model="form.entName" placeholder="请输入公司法定全称"/>
                  </a-form-model-item>
                  <a-form-model-item prop="name" label="姓名" v-if="this.activeTab==1">
                    <a-input v-model="form.name" placeholder="请输入姓名"/>
                  </a-form-model-item>
                  <a-form-model-item prop="idCard" label="身份证号码" v-if="this.activeTab==1">
                    <a-input v-model="form.idCard" placeholder="请输入身份证号码"/>
                  </a-form-model-item>

                  <a-form-model-item prop="defaultAmount" label="违约总金额（元）">
                    <a-input-number style="width: 100%" v-model="form.defaultAmount" placeholder="请输入违约总金额（元）" :min="0"/>
                  </a-form-model-item>
                  <a-form-model-item prop="overdueDate" label="逾期开始时间">
                    <a-date-picker
                        style="width: 100%"
                        format="YYYY-MM-DD"
                        v-model="form.overdueDate"
                        show-time
                        :disabledDate="disabledFutureDate"
                    />
                  </a-form-model-item>
                  <a-form-model-item prop="city" label="所在城市">
                    <a-cascader
                        :options="options"
                        :load-data="loadData"
                        change-on-select
                        v-model="form.city"
                        placeholder="请选择省份/城市"
                        @change="handleChange"
                        style="width: 100%"
                    />
                  </a-form-model-item>

                  <a-form-model-item prop="hasCollateral" label="有无抵押物">
                    <a-select v-model="form.hasCollateral" placeholder="请选择有无抵押物">
                      <a-select-option :value="1">有</a-select-option>
                      <a-select-option :value="0">无</a-select-option>
                    </a-select>
                  </a-form-model-item>

                  <a-form-model-item prop="industry" label="债务人所在行业" v-if="this.activeTab==0">
                    <a-input v-model="form.industry" placeholder="请输入债务人所在行业"/>
                  </a-form-model-item>
                </a-form-model>
              </div>
              <a-popconfirm title="查询报告需花费29.90元，确认查询吗？" @confirm="()=>searchQuery()">
                <button class="search-button">查询</button>
              </a-popconfirm>
            </div>
            <!--            <h3 class="platform-title-tag">商务诚信生态缔造者</h3>-->
          </div>
        </div>
      </div>
    </header>
  </div>

</template>

<script>
import Vue from 'vue'
import {ACCESS_TOKEN} from "@/store/mutation-types";
import {mapActions} from "vuex"
import {getAction} from "@/api/manage";
import { FormModel } from 'ant-design-vue';
Vue.use(FormModel);
export default {
  name: "Home",
  components: {},
  data() {
    return {
      contracts: [],
      anlist: [],
      activeIndex: 1, // 当前页index,
      options: [],
      selectedValues: [],
      selectedPath: [],
      activeTab:0,
      form: {
        name: '',
        entName:'',
        idCard: '',
        overdueDate: '',
        defaultAmount: '',
        city: [],
        hasCollateral: '',
        industry: '',
      },
      cityName:[],
      rules: {
        entName: [
          { required: true, message: '请输入公司法定全称', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}(\d|X)$/, message: '身份证号码格式不正确', trigger: 'blur' }
        ],
        overdueDate: [
          { required: true, message: '请输入逾期时长', trigger: 'change' }
        ],
        defaultAmount: [
          { required: true, message: '请输入违约总金额', trigger: 'blur' },
          { type: 'number', message: '请输入数字', trigger: 'blur' },
          { validator: this.validateAmount, trigger: 'blur' },
        ],
        city: [
          { required: true, message: '请输入所在城市', trigger: 'blur' }
        ],
        hasCollateral: [
          { required: true, message: '请输入有无抵押物', trigger: 'blur' }
        ],
        industry: [
          { required: true, message: '请输入债务人所在行业', trigger: 'blur' }
        ],
      },

    }
  },
  created() {
  },
  mounted() {
    this.loadProvinces();
  },
  watch: {},
  computed: {},
  methods: {
    disabledFutureDate(current) {
      // 当前日期之后的日期将被禁用
      return current && current > new Date();
    },
    validateAmount(rule, value, callback) {
      if (value < 0) {
        callback('金额不能为负数');
      } else {
        callback();
      }
    },
    switchTab(tab){
      this.activeTab = tab;
      this.$refs.ruleForm.clearValidate();
    },
    // 加载省份数据
    loadProvinces() {
      //
      getAction('/search/getProvincesList').then(res => {
        if (res.code == 200) {
          this.options = res.data.map(province => ({
            value: province.province_id,
            label: province.name,
            isLeaf: false, // 表示还有下级
          }));
        }
      })
    },

    // 动态加载子级数据
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];

      // 如果是省份，加载城市
      if (selectedOptions.length === 1) {
        const provinceCode = targetOption.value;
        getAction('/search/getCityList', {id: provinceCode}).then(res => {
          if (res.code == 200) {
            targetOption.children = res.data.map(city => ({
              value: city.city_id,
              label: city.name,
              isLeaf: true, // 城市是最末级
            }));
            // 触发视图更新
            this.options = [...this.options];
          }
        })
      }
    },

    // 选择变化处理
    handleChange(value, selectedOptions) {
      this.selectedValues = value;
      this.selectedPath = selectedOptions.map(option => option.label);
      this.cityName =this.selectedPath;
      // if(this.selectedPath.length==1){
      //   this.form.city = this.selectedPath[0];
      // }else if(this.selectedPath.length==2) {
      //   this.form.city = this.selectedPath[0]+'/'+this.selectedPath[1];
      // }

    },


    moreLaws() {
      this.$router.push('/lawsList')
    },
    searchQuery() {
      if (!Vue.ls.get(ACCESS_TOKEN)) {
        this.$message.error('请登录后查询！')
        return;
      }

      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let cn = this.cityName[this.cityName.length-1];
          if(this.cityName.length==2&&this.cityName[1]=='市辖区') {
            cn = this.cityName[0];
          }
          this.$router.push({
            name: 'report', params:
                {
                  name: this.form.name,
                  entName: this.form.entName,
                  idCard: this.form.idCard,
                  overdueDate: this.form.overdueDate.format('YYYY-MM-DD'),
                  defaultAmount: this.form.defaultAmount,
                  city: cn,
                  hasCollateral: this.form.hasCollateral,
                  industry: this.form.industry,
                  queryType: this.activeTab
                }
          });
        } else {

          return false;
        }
      });

      // if (this.keyword == '') {
      //   this.$message.warning('请输入企业法定全称')
      //   return;
      // }
    },
    zc() {
      this.$router.push('')
    },
    login() {
      this.$router.push('/login')
    },
    about(){
      this.$router.push('/about')
    },
    cz() {
      this.$router.push('/pay')
    },
    user() {
      this.$router.push('/user')
    },
    ...mapActions(["Logout"]),
    loginout() {
      const that = this
      that.Logout({}).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message)
          this.$router.push('/')
        } else {
          this.$message.error(res.message)
        }
      });
    },
    show() {
      if (this.$store.state.token) {
        return true;
      }
      return false;
    },
  },

}
</script>

<style scoped>
html,
body {
  position: relative;
  height: 100%;
  font: 14px "Microsoft Yahei", Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
  /* min-width: 1220px; */
  background-color: #060858 !important;
}

html div, body div {
  font-size: 15px;
}

.home-container {
  /*display: contents;*/
  /*overflow: hidden;*/
}

.utility-links {
  display: flex;
  list-style: none;
  padding: 0;
  align-items: center;
  margin: 0; /* 移除默认边距 */
  height: 100%; /* 填充父容器高度 */
}

.utility-links li {
  height: 100%; /* 填充父容器高度 */
  display: flex;
  align-items: center;
  padding: 0 12px; /* 调整水平间距 */
  position: relative;
}

.utility-links li a {
  color: black;
  opacity: 0.8;
  display: flex;
  align-items: center;
  height: 100%; /* 填充父容器高度 */
  padding: 0 4px; /* 增加点击区域 */
  font-size: 17px;
  font-weight: bold;
}

.utility-links li a:hover {
  opacity: 1;
  text-decoration: none;
}

.home-header {
  /*background: linear-gradient(135deg, #014298 0%, #4384ffc7 100%);*/
  /*height: 100vh;*/
  position: relative;
  overflow: hidden;
}


.header-top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0; /* 增加垂直内边距 */
  color: #fff;
  font-size: 14px;
  height: 48px; /* 固定高度 */
  min-width: 100%; /* 确保宽度填充 */
}

@media (max-width: 768px) {
  .header-top-bar {
    flex-wrap: nowrap; /* 防止换行 */
    padding: 8px 0;
  }
}

@media (max-width: 480px) {
  .header-top-bar {
    flex-direction: row; /* 保持水平布局 */
    justify-content: space-between;
    align-items: center;
  }
}

/* 基础样式 */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

@media (max-width: 768px) {
  .container {
    padding: 0 15px;
  }
}

.welcome-text {
  opacity: 0.8;
  flex: 1; /* 占据剩余空间 */
  white-space: nowrap; /* 防止文字换行 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 显示省略号 */
  padding-right: 15px; /* 右侧留白 */
  color: black;
}

@media (max-width: 480px) {
  .welcome-text {
    display: none; /* 超小屏幕隐藏 */
  }

}

.welcome-text li {
  height: 100%; /* 填充父容器高度 */
  display: flex;
  align-items: center;
  padding: 0 12px; /* 调整水平间距 */
  position: relative;
}

.welcome-text li a {
  color: #fff;
  opacity: 0.8;
  display: flex;
  align-items: center;
  height: 100%; /* 填充父容器高度 */
  padding: 0 4px; /* 增加点击区域 */
  font-size: 17px;
  font-weight: bold;
}

.header-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
}

.search-container {
  width: 100%;
  /*max-width: 800px;*/
  text-align: center;
}

.search-tabs {
  background: rgb(46 46 46 / 20%);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 20px;
  margin: 28px auto;
  height: auto;
  width: 100%;
}

.tab-content {
  position: relative;
}

.tab-content {
  position: relative;
}

.tab-pane {
  /*display: none;*/
  display: block;
}

.tab-pane .active {

}

.search-input-group {
  /*display: flex;*/
}

@media (max-width: 480px) {
  .search-input-group {
    flex-direction: column;
  }
}


.double-input {
  display: flex;
  flex: 1;
  gap: 1px;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .double-input {
    flex-direction: column;
    gap: 5px;
  }
}

.double-input .input-wrapper {
  position: relative;
}

.double-input .input-wrapper:before {
  /*content: '';*/
  /*position: absolute;*/
  /*left: 13px;*/
  /*top: 50%;*/
  /*transform: translateY(-50%);*/
  /*width: 24px;*/
  /*height: 24px;*/
  /*background: url("data:image/svg+xml,%3csvg%20t='1751645347119'%20class='icon'%20viewBox='0%200%201024%201024'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20p-id='8696'%20width='32'%20height='32'%3e%3cpath%20d='M619.712%20198.187V801.45h44.544v-0.854h102.763V446.08l-102.763-36.181V342.08l144.576%2050.88a48.723%2048.723%200%200%201%2022.037%2037.077l0.15%203.798-0.022%20367.594h48.918v64H213.46v-64h48.64l0.022-489.493c0-16.81%208.661-32.427%2022.912-41.365L545.088%20156.8c32.49-20.288%2074.624%203.05%2074.624%2041.344z%20m-64%2023.85l-229.59%20100.438v478.101h229.611V533.461l-0.426%200.192v-29.61l0.426%201.002V381.867l-0.426%200.192v-29.526l0.426%200.982V222.037zM512.32%20482.176v69.227l-142.763%2058.965V541.12l142.763-58.944z%20m0-151.36v69.525L369.557%20461.1v-69.547l142.763-60.736z'%20p-id='8697'%20fill='%238a8a8a'%3e%3c/path%3e%3c/svg%3e") no-repeat center/contain;*/
}

@media (max-width: 480px) {
  .double-input .input-wrapper {
    width: 100%;
  }
}

.input-wrapper input {
  width: 60%;
  height: 50px;
  padding: 0 0 0 10px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
}

.input-wrapper span {
  color: white;
  font-size: 27px;
}

@media (max-width: 768px) {
  .input-wrapper input {
    height: 45px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .input-wrapper input {
    width: 100%;
  }
}

.input-wrapper-first {
  flex: 1.2;
}

.search-button {
  width: 200px;
  height: 50px;
  background: linear-gradient(90deg, #0061ff, #606eff);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
}

@media (max-width: 768px) {
  .search-button {
    height: 45px;
    font-size: 16px;
    width: 110px;
  }

}

@media (max-width: 480px) {
  .search-button {
    width: 100%;
    margin-top: 20px;
  }
}

.platform-title {
  color: black;
  font-size: 46px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  font-weight: 600;
  text-align: center;
}

.platform-title::after {
  content: '';
  position: absolute;
  top: 215px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: #fff;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.5);
}

@media (max-width: 992px) {
  .platform-title {
    font-size: 40px;
  }
}

@media (max-width: 768px) {
  .platform-title {
    font-size: 32px;
    margin: 15px 0;
  }
}

@media (max-width: 480px) {
  .platform-title {
    font-size: 28px;
  }
}

.platform-title-tag {
  color: black;
  font-size: 30px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  font-weight: 500;
  font-family: 华文行楷;
  margin-top: 50px;
}

.home-content {
  padding: 40px 0;
}

@media (max-width: 768px) {
  .home-content {
    padding: 30px 0;
  }
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 政策法规区域 */
.policy-section {
  margin-bottom: 80px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.section-title {
  color: #014298;
  font-size: 32px;
  font-weight: 600;
}

.view-all-link {
  color: #014298;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: all 0.3s;

}

.arrow-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 5px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%230061ff'%3E%3Cpath d='M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z'/%3E%3C/svg%3E") no-repeat center;
  transition: all 0.3s;
}


.policy-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 25px;
}

@media (max-width: 768px) {
  .policy-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
}

.policy-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  padding: 25px;
  transition: all 0.3s ease;
  border-left: 4px solid #014298;
}

@media (max-width: 768px) {
  .policy-card {
    padding: 20px;
  }
}

.policy-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 12px;
  line-height: 1.4;
}

.policy-desc {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  margin: 0;
}

.search-main-box {
  width: 1000px;
  display: flex;
  margin: auto;
}

@media (max-width: 1200px) {
  .search-main-box {
    width: 800px;
  }
}


.search-main-ipt {
  width: 85%;
}

.search-main-input-con {
  width: 100%;
  background-color: #ffffff1a;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #161617;
  height: 40px;
  outline: 0;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  background-image: none;
}

.search-main-btn {
  width: 120px;
  height: 40px;
  bottom: 20px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  background: rgb(1 66 152);
  color: #fff;
  border-radius: 0;
  cursor: pointer;
}

/* 新增API服务区域样式 */
.api-service-section {
  background: #fff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 80px;
  border-top: 4px solid #014298;
}

.api-service-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.api-service-section .section-title {
  color: #014298;
  font-size: 32px;
  font-weight: 600;
}

.api-service-section .section-intro {
  margin-bottom: 30px;

}

.api-service-section .section-intro p {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 15px;
}

.api-service-section .api-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 25px;
}

.api-service-section .api-card {
  background: #fff;
  border-radius: 8px;
  padding: 25px;
  transition: all 0.3s ease;
  border-left: 3px solid #5ACCC7;
  height: 100%;
}

.api-service-section .api-card .api-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
  background-color: rgba(74, 137, 220, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a89dc;
  font-size: 28px;
}

.api-service-section .api-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
  text-align: center;
}

.api-service-section .api-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  text-align: center;
  margin: 0;
}

.solutions-section {
  margin-bottom: 80px;
}

.solutions-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.solutions-section .section-title {
  color: #014298;
  font-size: 32px;
  font-weight: 600;
}

.solutions-section .solutions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
}

.solutions-section .solution-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  padding: 30px;
  transition: all 0.3s ease;
  text-align: center;
  border-top: 4px solid #014298;
  height: 100%;
}

.solutions-section .solution-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
  background-color: rgba(74, 137, 220, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a89dc;
  font-size: 28px;
}

.solutions-section img {
  width: 32px;
  height: 32px;
}


.solutions-section .solution-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
}

.solutions-section .solution-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

/* 新增联合招聘区域样式 */
.recruitment-section {
  margin-bottom: 80px;
}

.recruitment-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.recruitment-section .section-title {
  color: #014298;
  font-size: 32px;
  font-weight: 600;
}

.recruitment-section .section-intro {
  margin-bottom: 30px;
}

.recruitment-section .section-intro p {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 15px;
}

.recruitment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.recruitment-title {
  background: linear-gradient(135deg, rgba(74, 137, 220, 0.1) 0%, rgba(255, 255, 255, 0.2) 100%);
  border-radius: 12px;
  padding: 25px;
  transition: all 0.3s ease;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  border: 1px solid rgba(74, 137, 220, 0.15);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.site-footer {
  background: rgb(1 66 152);
  color: rgba(255, 255, 255, 0.8);
  height: auto;
  font-size: 14px;
  position: relative;

}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.footer-content {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  gap: 20px;
}

.footer-main {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  gap: 30px;
  margin-top: 20px;
}

.footer-links {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .footer-links {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .footer-links {
    grid-template-columns: 1fr;
  }

  .footer-main {
    padding-bottom: 30px;
  }
}

.link-column {
  min-width: 180px;
}

.link-column h4 {
  color: #fff;
  font-size: 18px;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
  font-weight: 500;
}

.link-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.link-column ul li {
  margin-bottom: 12px;
}

.link-column ul li a {
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.3s;
  display: inline-block;
}

.link-column ul li a:hover {
  color: #fff;
  transform: translateX(5px);
}

.contact-info p {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.contact-info p .icon {
  color: #4a89dc;
  font-size: 16px;
  flex-shrink: 0;
}

.friend-links {
  width: 100%;
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.friend-links h4 {
  color: #fff;
  font-size: 18px;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
  font-weight: 500;
}

.friend-links-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 15px;
}

.friend-links-grid a {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  transition: all 0.3s ease;
  text-align: center;
  min-height: 40px;
}

.friend-links-grid a:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  transform: translateY(-3px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.friend-links-grid a:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

.footer-bottom {
  background: rgb(1 66 152);
  padding: 20px 0px 80px 0px;
  text-align: center;
}

.footer-bottom .copyright {
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  /*margin-bottom: 10px;*/
}

.footer-bottom .copyright p {
  margin: 5px 0;
}

.tab-nav {
  display: flex;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
}
.tab-nav li {
  margin: 0 10px;
}
.tab-nav li a {
  display: block;
  padding: 13px 30px;
  color: #fff;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50px;
  transition:  all 0.3s ease;
  font-size: 16px;
}
.tab-nav li a:hover {
   background: rgba(255, 255, 255, 0.1);
 }

.active  {
   background-color: #0769ea;
   border-color: #0769ea;
   color: #fff;
  border-radius: 50px;
 }

</style>

